import {
  PERK,
  GIVE_PERKS,
  PERK_CLICK,
  VERIFY_PERK_REDEEM,
  PERK_INTEREST,
} from './perk';
import PERK_APPROVAL_REQUEST from './perkApprovalRequest';
import GROUP from './group';
import EMAIL_DOMAIN from './emailDomain';
import BLOCK_EMAIL_EXPRESSION from './blockEmailExpression';
import GENERAL from './general';
import { EMPLOYEE, EMPLOYER, USER, USER_FEEDBACK, USER_HISTORY } from './user';
import SETTINGS from './settings';
import INVITES from './invites';
import { CATEGORY, PERK_CATEGORY, SUB_CATEGORY } from './category';
import SENTRY from './sentry';
import PERK_REDEEM_CODES from './perkRedeemCodes';
import TEST_ACCOUNTS from './testAccounts';
import STRIPE from './stripe';
import DISCOUNT_CODE from './discount';
import ROLE from './role';
import PERMISSION from './permission';
import AUTH from './auth';
import PROFILE from './profile';
import BUDGET from './budget';
import VOUCHER from './voucher';
import {
  CAROUSEL,
  BRAND_CAROUSEL,
  CAROUSEL_SETTINGS,
  BRAND_CAROUSEL_SETTINGS,
  CUSTOM_CATEGORY_ICONS,
} from './carousel';
import { CARD, CARD_SETTINGS, CREDIT_CARD } from './card';
import ORDER from './order';
import { APPS_INTEGRATIONS, MOBILE_APP_FORCE_EXCLUDE } from './mobileApp';
import { SLACK_BOT, SLACK } from './slack';
import MS_TEAMS from './msTeams';
import { PUSH_NOTIFICATIONS } from './notifications';
import MIGRATION from './migration';
import SETUP from './setup';

export const MESSAGES = {
  SETUP,
  PERK,
  GIVE_PERKS,
  GROUP,
  EMAIL_DOMAIN,
  DISCOUNT_CODE,
  GENERAL,
  USER,
  USER_HISTORY,
  SETTINGS,
  INVITES,
  SLACK,
  SLACK_BOT,
  CATEGORY,
  SUB_CATEGORY,
  SENTRY,
  PERK_REDEEM_CODES,
  TEST_ACCOUNTS,
  STRIPE,
  BLOCK_EMAIL_EXPRESSION,
  MS_TEAMS,
  PERK_APPROVAL_REQUEST,
  ROLE,
  PERMISSION,
  AUTH,
  PROFILE,
  BUDGET,
  EMPLOYEE,
  VOUCHER,
  CAROUSEL,
  BRAND_CAROUSEL,
  CARD,
  CAROUSEL_SETTINGS,
  BRAND_CAROUSEL_SETTINGS,
  CARD_SETTINGS,
  PERK_CLICK,
  PERK_CATEGORY,
  EMPLOYER,
  USER_FEEDBACK,
  VERIFY_PERK_REDEEM,
  ORDER,
  CREDIT_CARD,
  CUSTOM_CATEGORY_ICONS,
  PERK_INTEREST,
  MOBILE_APP_FORCE_EXCLUDE,
  APPS_INTEGRATIONS,
  PUSH_NOTIFICATIONS,
  MIGRATION,
} as const;
